import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const TextField = styled(MuiTextField)({
  "& .MuiInputBase-input": {
    padding: "11px",
    background: "white",
    borderRadius: "8px",
    fontSize: "15px",
  },

  "& fieldset": {
    borderRadius: "8px",
    border: "1px solid #DCDCDC",
  },
});

export default TextField;
